import { render, staticRenderFns } from "./AppProductsView.vue?vue&type=template&id=3dc5a688"
import script from "./AppProductsView.vue?vue&type=script&lang=js"
export * from "./AppProductsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports